<ng-container *ngIf="(_loading.isLoading$ | async) === false">
	<h1 mat-dialog-title class="rtl text-align-start">{{ title$ | async }}</h1>

	<div mat-dialog-content class="rtl" style="font-size: 16px; font-weight: 600">
		<!-- <h4>{{ data.clientid }} - {{ data.clientName }}</h4> -->

		<form dir="rtl" class="grid" [formGroup]="form">
			<ng-container *ngFor="let field of fields">
				<mat-form-field color="primary" *ngIf="allFields[field].display">
					<mat-label>{{ allFields[field].text }}</mat-label>
					<input matInput [formControlName]="field" [placeholder]="allFields[field].text" />
					<mat-error>{{ getFormErrorMessage(field) }}</mat-error>
				</mat-form-field>
			</ng-container>
		</form>
	</div>
	<div mat-dialog-actions class="justify-between">
		<button mat-button mat-dialog-close cdkFocusInitial>סגור</button>
		<button mat-raised-button color="primary" [disabled]="form.invalid" (click)="handleAction()">{{ buttonTitle$ | async }}</button>
	</div>
</ng-container>
